"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroupBox = RadioGroupBox;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const styled_components_1 = __importStar(require("styled-components"));
function RadioGroupBox({ boxes, children, defaultValue, buttonStyle, onChange, size = 'middle', value, disabled, }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "rgb-ant-wrapper", children: [(0, jsx_runtime_1.jsx)(RadioGroupBoxAntOverride, { isDisabled: disabled }), (0, jsx_runtime_1.jsxs)(antd_1.Radio.Group, { disabled: disabled, value: value, defaultValue: defaultValue, buttonStyle: buttonStyle, onChange: onChange, children: [boxes.map(box => ((0, jsx_runtime_1.jsx)(Box, { value: box.value, size: size, children: (0, jsx_runtime_1.jsxs)(BoxContentWrapper, { children: [box.icon, box.label] }) }, box.value))), children] })] }));
}
const Box = (0, styled_components_1.default)(antd_1.Radio.Button) `
	${({ size }) => {
    switch (size) {
        case 'large':
            return (0, styled_components_1.css) `
					width: 120px;
					height: 120px;
					padding: 0.8rem 0.5rem;
				`;
        case 'middle':
            return (0, styled_components_1.css) `
					width: 60px;
					height: 60px;
					padding: 0.125rem;
				`;
        case 'small':
            return (0, styled_components_1.css) `
					width: 24px;
					height: 24px;
					padding: 0.125rem;
				`;
        default:
            return '';
    }
}}
	text-align: center;
	font-size: 12px;
	line-height: 12px;
	svg {
		max-width: 60px;
		max-height: 60px;
		margin-bottom: 1rem;
	}
	.anticon {
		width: 60px;
		height: 60px;
		margin-bottom: 1rem;
	}
`;
const BoxContentWrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
`;
const RadioGroupBoxAntOverride = (0, styled_components_1.createGlobalStyle) `
	.rgb-ant-wrapper{
		display: flex;
		.ant-radio-group {
			display: flex;
			gap: 1rem;
			justify-content: center;
			flex-wrap: wrap;
		}
		.ant-radio-button-wrapper {
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 8px;
			border: 2px solid ${({ theme }) => theme.color.gray5};
			box-shadow: none !important;

			&:hover {
				${({ isDisabled }) => !isDisabled &&
    (0, styled_components_1.css) `
						border: 2px solid ${({ theme }) => theme.color.brand1};
					`}
			}
			&::before {
				content: none;
			}
			.ant-radio-button,
			.ant-radio-button-checked
			{
				border: none;
			}
		}
		.ant-radio-button-wrapper-checked {
			border-radius: 8px;
			outline: none;
			border: 2px solid ${({ theme }) => theme.color.brand1} !important;
			box-shadow: none;

			
			&:hover {
				${({ isDisabled }) => !isDisabled &&
    (0, styled_components_1.css) `
						border: 2px solid ${({ theme }) => theme.color.brand1};
					`}
			}
		}
	}
`;
